export default __webpack_public_path__ + "static/media/blueTheme-girl.645cdd7e.svg";